import { Component, signal, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from "@angular/material/dialog";
import { MatFormFieldModule, MatLabel } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatOption, MatSelect } from "@angular/material/select";
import { TranslocoPipe } from "@jsverse/transloco";
import { LorenFileUploadModule } from "../../../../shared/modules/loren-file-upload/loren-file-upload.module";
import { LorenNumberModule } from "../../../../shared/pipes/loren-number/loren-number.module";
import { MatButton } from "@angular/material/button";

@Component({
  selector: "loren-loren-asset-details-upload-photo-dialog",
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatLabel,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatSelect,
    MatOption,
    TranslocoPipe,
    LorenFileUploadModule,
    LorenNumberModule,
    MatButton,
  ],
  templateUrl: "./loren-asset-details-upload-photo-dialog.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./loren-asset-details-upload-photo-dialog.component.scss",
})
export class LorenAssetDetailsUploadPhotoDialogComponent {
  dialogRef = inject<MatDialogRef<LorenAssetDetailsUploadPhotoDialogComponent>>(MatDialogRef);
  data = inject<{
    assetName: string;
}>(MAT_DIALOG_DATA);

  photo = signal<{ file: string; name: string; size: number }>(null);
  status = signal<string>("VERY_GOOD");
  comment = signal<string>(null);
  fileSizeExceededError = signal<boolean>(false);
  fileTypeMismatchError = signal<boolean>(false);

  readonly statuses = ["VERY_GOOD", "GOOD", "BAD", "VERY_BAD"];

  successfulFileUploadHandler(event) {
    this.fileSizeExceededError.set(false);
    this.fileTypeMismatchError.set(false);
    this.photo.set(event);
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
